// extracted by mini-css-extract-plugin
export default {"wrapper":"PageHeader_wrapper__73HPx","details":"PageHeader_details__w4sjZ"};